import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register service worker (only in production)
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
})
      .catch((error) => {
});
  });
}
